import type { TranslationCatalog } from "../TranslationManager";

export const pl: TranslationCatalog = {
  "labels.cardNumber": "Numer karty",
  "labels.expirationDate": "Data ważności",
  "labels.cvc": "Kod bezpieczeństwa",
  "placeholders.cardNumber": "1234 1234 1234 1234",
  "placeholders.expirationDate": "MM / RR",
  "placeholders.cvc": "CVV",
  "errors.invalidCardNumber": "Numer karty jest nieprawidłowy.",
  "errors.invalidExpiryDate": "Data ważności karty jest nieprawidłowa.",
  "errors.invalidCvc": "Kod bezpieczeństwa karty jest nieprawidłowy.",
  "errors.incompleteCardNumber": "Numer karty jest niekompletny.",
  "errors.incompleteExpiryDate": "Data ważności karty jest niekompletna.",
  "errors.incompleteCvc": "Kod bezpieczeństwa karty jest niekompletny.",
  "errors.expiredCard": "Twoja karta wygasła.",
  "aria.cardNumber": "Numer karty",
  "aria.expirationDate": "Data ważności",
  "aria.cvc": "Kod bezpieczeństwa",
  "aria.cardInput": "Dane karty",
};
